import {
  AdditionalPocContactErrorsType,
  AdditionalPocContactType,
  AdditionalPocContactValueType,
  POCErrorFieldsType,
  UserProfileErrorState,
  UserProfileState
} from 'src/lib/types/settings'
import { validateEmail, validatePhone } from 'src/lib/utils/helpers'
import { regexPatterns } from './validations'
import { postRequest } from '../core/api-client'
import { apiURI } from './constants'

export const validateField = (fieldName: string, value: string) => {
  let error: POCErrorFieldsType = { status: false, message: '' }
  switch (fieldName) {
    case 'name':
      if (!value.trim() || value.length < 3) {
        error = { status: true, message: 'Please enter at least 3 character in your name' }
      }
      break
    case 'email':
      if (!validateEmail(value)) {
        error = { status: true, message: 'Invalid Email' }
      } else if (value.includes('+')) {
        error = { status: true, message: 'Plus sign (+) is not allowed' }
      }
      break
    case 'phone':
      if (!validatePhone(value) || value.length < 12) {
        error = { status: true, message: 'Please enter 10 digit phone number' }
      }
      break
    default:
      break
  }
  return error
}

export const createNewPocContact = () => {
  const newPocContact = {
    values: { name: '', email: '', phone: '', designation: '' },
    errors: {
      name: { status: false, message: '' },
      email: { status: false, message: '' },
      phone: { status: false, message: '' },
      designation: { status: false, message: '' }
    }
  }
  return newPocContact
}

export const parseAdditionalPocContactsForBackend = (
  data: AdditionalPocContactType[],
  primaryPocContact: AdditionalPocContactValueType
) => {
  const additionalPocDetails = data.map((data: AdditionalPocContactType) => {
    return {
      email: data.values.email,
      name: data.values.name,
      phone: data.values.phone,
      designation: data.values.designation,
      primary: false
    }
  })
  return [...additionalPocDetails, primaryPocContact]
}

export const parseAdditionalPocContacts = (data: any): AdditionalPocContactType[] => {
  if (!Array.isArray(data)) return []
  return data.map((data: AdditionalPocContactValueType) => {
    return {
      values: {
        name: data?.name ?? '',
        email: data?.email ?? '',
        phone: data?.phone ?? '',
        designation: data?.designation ?? ''
      },
      errors: {
        name: { status: false, message: '' },
        email: { status: false, message: '' },
        phone: { status: false, message: '' },
        designation: { status: false, message: '' }
      }
    }
  })
}

export const scrollIntoAdditionalPocErrors = (pocContactsErrors: AdditionalPocContactErrorsType[]) => {
  for (let index = 0; index < pocContactsErrors.length; index++) {
    const contact = pocContactsErrors[index]
    for (const field in contact) {
      if (contact[field as keyof AdditionalPocContactErrorsType]?.status) {
        const element = document.getElementById(`additional_poc_${field}_${index}`)
        return element
      }
    }
  }
}

export const parsePrimaryPocContact = (phone: string) => {
  if (!phone) return ''
  if (phone.length === 10) {
    return `91${phone}`
  }
  return phone
}

export const validateRecipient = (recipient: UserProfileState): UserProfileErrorState => {
  const errors: UserProfileErrorState = {
    firstName: false,
    phoneNumber: false,
    email: false,
    role: false
  }

  if (!Boolean(recipient?.firstName) || recipient?.firstName?.match(regexPatterns.alphaNumericExcludesSpace)) {
    errors.firstName = true
  }

  if (!Boolean(recipient?.phoneNumber) || recipient?.phoneNumber?.length < 3 || recipient?.phoneNumber.length < 12) {
    errors.phoneNumber = true
  }

  if (recipient?.email && !validateEmail(recipient?.email)) {
    errors.email = true
  }

  return errors
}

export const generateOauthLink = async (type: string, state: 'SETTING' | 'ORGANIZATION') => {
  const response: any = await postRequest('/pg/oauth/initiate', apiURI.FMS_ENGINE, {
    pg_name: type,
    state
  })

  const oAuthLink = response?.data

  window.open(oAuthLink, '_blank', 'noopener,noreferrer')
}

export const mapSettingsPageKeyToQueryParam = (pageKey: string | undefined) => {
  if (!pageKey) return ''
  switch (pageKey) {
    case 'payments':
      return 'payments'
    case 'integrations':
      return 'integrations'
    case 'shop-details':
      return 'shopDetails'
  }
}
